<script>
  import AccordionInput from "./metadataInput.svelte"
  import notify from "../../../../../Script/notify"
  import { onDestroy, createEventDispatcher } from "svelte"
  import templateStore, { templateToJSON, jsonToTemplate } from "../../../../../Stores/metadataStore"
  import { removeEmptyKeys } from "../../../../../Script/removeEmptyKey"
  import ApplicationState from "../../../../../Stores/applicationStates"
  import TemplatesList from "../../../../../Stores/templatesList"

  export let namespace = ""
  export let json = {}

  const dispatch = createEventDispatcher()

  /**
   * @typedef {Object} Notification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {Notification}
   */
  let notification = {
    /**
     * Closes the notification.
     */
    close() {},
  }

  /**
   * @typedef {Object} focusNotification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {focusNotification}
   */
  let focusNotification = {
    /**
     * Closes the notification.
     */
    close() {},
  }

  /**
   * @type {Boolean} - check if input element is focused
   */
  let isChildFocused = true

  /**
   * @description -function for changing values by holding keys unchanged
   * @param {String} id -id of the object
   * @param {String} newValue -value changing in existing value from stores
   */
  const changeValue = (id, newValue) => {
    templateStore.update((templateData) => {
      //updating stores with new values
      templateData.find((data) => {
        if (data.id == id) {
          data.value = newValue
        }
      })
      return templateData
    })
  }

  /**
   * @description - function to change keys in object from stores
   * @param id - id of the object
   * @param newKey -changed value of the existing key
   */
  const changeKey = (id, newKey) => {
    templateStore.update((templateData) => {
      //updating stores with new changed keys by finding respected id
      templateData.find((templateJson) => {
        if (templateJson.id == id) {
          templateJson.key = newKey
          templateJson.id = `${templateJson.parent}.${templateJson.key}`
        }
      })
      //for nested objects
      templateData.forEach((jsonTemplate) => {
        if (jsonTemplate.parent.indexOf(`${id}.${newKey}`) == 0) {
          jsonTemplate.parent = `${id}.${newKey}`
          jsonTemplate.id = `${jsonTemplate.parent}.${jsonTemplate.key}`
        }
      })

      //  trimSpacesMetadata(newKey, "Only spaces not allowed")
      return templateData
    })
  }

  /**
   * @description - function to delete single row
   * @param id - id of correspoding row to be deleted
   */
  const deleteRow = (id) => {
    //splitting keys and returns new array
    let key = id.split(".")
    //returns last item of the array
    key = key[key.length - 1]
    //not to delete mandatory id's
    if (id == "issuer.signatory" || id == "receiver.name" || id == "document.type") {
      notification.close()
      const info = "PAGE: Edit document template\nEVENT: While deleting metadata row"
      notification = notify.danger(`<strong>${key}</strong> should not be deleted`, info)
      return
    }
    //deleting other than mandatory rows
    templateStore.update((templateData) => {
      return templateData.filter((templateJson) => templateJson.id != id)
    })
    if (key) {
      notify.info(`<strong  style="hyphens: auto;">${key}</strong> value pair successfully deleted.`)
    } else {
      notify.info(`<strong>Empty</strong> row successfully deleted.`)
    }
  }

  onDestroy(() => {
    // Update the templateStore with the modified JSON data.
    templateStore.update((templateData) => {
      // Convert the templateData to JSON and assign it to the `json` variable.
      json = templateToJSON(templateData)

      // Remove any empty keys from the `json` object.
      removeEmptyKeys(json)

      // Convert the modified JSON object back to template data.
      return jsonToTemplate(json)
    })

    if ($TemplatesList.disabled) {
      $TemplatesList.disabled = false
    }
  })
</script>

<div class="relative w-full select-none pl-4">
  {#if json}
    {#each Object.entries(json) as [key, value]}
      {#if typeof value == "object"}
        <svelte:self json={value} namespace={namespace ? `${namespace}.${key}` : key} />
      {:else}
        <div class="flex flex-col">
          <div class="mt-3 flex items-center gap-3 md:justify-between">
            <div class="flex w-full flex-col items-center justify-center gap-2 last:pb-8 mobile:flex-row">
              <div class="w-full mobile:w-1/3">
                <AccordionInput
                  on:inputChange={(e) => {
                    changeKey(e.detail.id, e.detail.value)
                    if (!e.detail.value) {
                      dispatch("checkKey", false)
                    } else {
                      dispatch("checkKey", true)
                    }
                  }}
                  maxCharacters="30"
                  placeholder="Enter Key"
                  value={key}
                  keyValue={!key}
                  isFocused={isChildFocused}
                  id={namespace ? `${namespace}.${key}` : key}
                  key={true}
                />
              </div>
              <div class="w-full mobile:w-2/3">
                <AccordionInput
                  on:inputChange={(e) => {
                    changeValue(e.detail.id, e.detail.value)
                  }}
                  placeholder="Enter Value (optional)"
                  {value}
                  maxCharacters="120"
                  keyValue={key}
                  id={namespace ? `${namespace}.${key}` : key}
                />
              </div>
            </div>
            <div data-tooltip="Delete field" tooltip-position="top">
              <button
                type="button"
                class="ml-auto flex h-8 w-8 cursor-pointer items-center justify-center rounded-full text-gray-400 hover:bg-red-500 hover:text-white focus-visible:bg-red-500 focus-visible:text-white focus-visible:outline-none"
                on:click|stopPropagation={() => {
                  deleteRow(`${namespace}.${key}`)
                  if (!key) {
                    $TemplatesList.disabled = false
                  }
                }}
              >
                <i class="fa-solid fa-trash-can" />
              </button>
            </div>
          </div>
        </div>
      {/if}
    {/each}
  {/if}
</div>
